export default class SolicitanteDataModel {
  constructor() {
    this.id = 0
    this.nome = ''
    this.email = ''
    this.celular = ''
    this.cpf = ''
  }
}
